<div class="flex w-[400px] flex-col items-center gap-8">
  <img src="svgs/warning.svg" class="h-28" />

  <div class="flex flex-col gap-2">
    <h1 class="text-base" i18n>
      Oh no, Something went wrong. We're sorry about that!
    </h1>

    <error-small-component></error-small-component>
  </div>

  <button
    *ngIf="errorStore.resolution().strategy !== 'none'"
    (click)="resolution()"
    pButton
    pRipple
    label="Reload"
    class="mt- !text-sm"></button>
</div>
